<template>
  <div class="mobile-promo-bar">
    <div class="promo-link" @click="openRegisterModal">
      <img
        :src="promoImages[currentIndex]"
        alt="프로모션"
        class="promo-img"
      />
    </div>
  </div>
</template>

<script>
import promo1 from '@/assets/promo/001.png'
import promo2 from '@/assets/promo/002.png'
import promo3 from '@/assets/promo/003.png'
import promo4 from '@/assets/promo/004.png'

export default {
  name: 'MobilePromoBar',
  data() {
    return {
      currentIndex: 0,
      promoImages: [promo1, promo2, promo3, promo4],
      timer: null
    }
  },
  mounted() {
    this.startSlide()
  },
  beforeUnmount() {
    this.stopSlide()
  },
  methods: {
    startSlide() {
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.promoImages.length
      }, 1000)
    },
    stopSlide() {
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    openRegisterModal() {
      window.dispatchEvent(new CustomEvent('open-register-modal'))
    }
  }
}
</script>

<style scoped>
.mobile-promo-bar {
  position: sticky;
  top: 60px; /* 헤더 높이 */
  z-index: 700;
  background: #1a1a1a;
}

.promo-link {
  display: block;
  width: 100%;
  cursor: pointer;
}

.promo-img {
  width: 100%;
  height: auto;
  display: block;
}

/* 페이드 애니메이션 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
